var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "bo-node-content", attrs: { fluid: "" } },
        [
          _c("meta-content", { attrs: { metaContentNodes: _vm.bonode } }),
          _vm._v(" "),
          _c("headlinesLight", { attrs: { category: "BettingHeadlines" } }),
          _vm._v(" "),
          _c("bo-navigation", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.bonode && _vm.bonode.idfwbonavigation,
                expression: "bonode && bonode.idfwbonavigation"
              }
            ],
            staticClass: "child-navigation",
            attrs: { "preselect-first-node": true, astabs: "true" }
          }),
          _vm._v(" "),
          !_vm.isInPlayBoNode
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "tab-coupons" },
                  _vm._l(_vm.tabCouponNodes, function(tabCoupon) {
                    return _c(
                      "div",
                      { key: tabCoupon.idfwbonavigation },
                      [
                        _c("tab-coupon", {
                          attrs: { tabcouponnode: tabCoupon }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.marketgroups && _vm.marketgroups.length > 0
                  ? _c(
                      "div",
                      { staticClass: "marketgroups" },
                      _vm._l(_vm.marketgroups, function(mg) {
                        return _c("market-group", {
                          key: mg.idfwmarketgroup,
                          attrs: {
                            idfwmarketgroup: mg.idfwmarketgroup,
                            "events-grouping": _vm.bonode.displaytemplatename,
                            maxevents: _vm.bonode.maxitems || 0
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isInPlayBoNode
            ? _c(
                "div",
                [
                  _c("live-coupon", {
                    attrs: {
                      ontab: true,
                      idfosporttypescsv: _vm.bonode.csvparameters || "ALL",
                      maxeventspersporttype: _vm.bonode.maxitems,
                      couponname: _vm.bonode.name
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-454d2a48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454d2a48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/BoNodeContent.vue
// module id = null
// module chunks = 